import { ReactElement } from 'react';
import styled, { css, CSSProp } from 'styled-components';

interface ContainerProps {
  innerStyle?: CSSProp;
}

interface IconProps {
  iconStyle?: CSSProp;
}

interface BackgroundLayoutProps extends ContainerProps, IconProps {
  children: React.ReactNode;
  transparent?: boolean;
  showIcon?: boolean;
}

const InnerContainer = styled.div<ContainerProps>`
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 100px;
  flex: 1;
  display: flex;

  ${({ innerStyle }) =>
    innerStyle &&
    css`
      ${innerStyle}
    `}
`;

const Icon = styled.img<IconProps>`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 480px;
  height: 500px;

  ${({ iconStyle }) =>
    iconStyle &&
    css`
      ${iconStyle}
    `}
`;

export const BackgroundLayout = ({
  children,
  innerStyle,
  iconStyle,
  transparent,
  showIcon = true
}: BackgroundLayoutProps): ReactElement => {
  return (
    <div className="background-layout">
      <InnerContainer innerStyle={innerStyle}>{children}</InnerContainer>
      {showIcon && (
        <Icon iconStyle={iconStyle} src={'../../assets/images/so-mds_background_icon.png'} />
      )}
    </div>
  );
};
